export const SEARCH_PLACEHOLDER = 'Name, email, NPN, agency...';

export const fieldLabelClass =
  'block text-xs font-medium leading-tight text-grey-dark mb-1';

export const pillSearchSx = {
  maxWidth: { xs: '100%', sm: 360, md: 320 },
  '& .MuiOutlinedInput-root': {
    minHeight: 34,
    borderRadius: '10px',
    backgroundColor: '#fff',
    fontSize: '0.8125rem'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--color-grey-lighter, #d0d0d1)'
  },
  '& .MuiInputBase-input': {
    py: '6px',
    lineHeight: 1.35
  }
};

/**
 * builds the sx for the toolbar's select fields
 * @param stacked - true when the fields are laid out in a column (mobile filters popover)
 */
export function selectSx(stacked) {
  return {
    minWidth: stacked ? undefined : '7.5rem',
    flex: stacked ? undefined : '0 1 auto',
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      backgroundColor: '#fff',
      fontSize: '0.875rem'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-grey-lighter, #d0d0d1)'
    },
    '& .MuiInputBase-input': {
      py: 1,
      px: 0.75
    }
  };
}
